import React from "react";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import ProductionList from "./ProductionList";
import { ModalPickerProps } from "../props";
import RemovableProduction from "components/Removables/RemovableProduction";
import { NewProductionModal } from "Production/New/NewProductionModal";

const ProductionModalPicker = (props: ModalPickerProps<server.dto.ProductionSmallV2>) => {
  const [displayNewProduction, setDisplayNewProduction] = React.useState(false);

  return <>
    {displayNewProduction && <NewProductionModal
      isOpen
      onClose={() => setDisplayNewProduction(false)}
      onCreated={(production) => {
        setDisplayNewProduction(false);
        props.onChange(production);
      }}
    />}
    <ModalPickerWithChooseButton
      canCreateNew={props.canCreateNew}
      onNewClicked={() => setDisplayNewProduction(true)}
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={site.currentEnvironment.production.plural}
      modalSize="tiny"
      renderModalContent={(closeModal) => <ProductionList
        excludeKeys={props.excludeKeys}
        onItemSelected={(production) => {
          closeModal();
          props.onChange(production);
        }}
      />}
      renderRemovable={(props) => <RemovableProduction {...props} />}
      {...props}
    />
  </>
};

export default ProductionModalPicker;